<template>
  <div class="aftersale">
    <UserInfo class="userInfo" v-bind="aftersale"></UserInfo>
    <UserInfo class="userInfo" v-bind="promise"></UserInfo>
    <UserInfo class="userInfo" v-bind="qualityBook"></UserInfo>
    <UserInfo class="userInfo" v-bind="serverBook"></UserInfo>
  </div>
</template>

<style scoped>
.aftersale {
  width: calc(100% - 32px - 64px);
  /* 64是padding */
  max-width: 1366px;
  margin: 0 auto;
  background-color: #ffffff;
  overflow: hidden;
  margin-top: 32px;
  margin-bottom: 132px;
  padding: 32px;
}
.userInfo {
  margin-bottom: 32px;
}
</style>

<script>
import UserInfo from "@/components/UserInfo.vue";
export default {
  components: {
    UserInfo
  },
  data() {
    return {
      aftersale: {
        title: `联系售后`,
        arr: [
          {
            title: "售后热线",
            content: "+86-(0)411-87868755"
          }
        ]
      },
      promise: {
        title: "服务宗旨",
        arr: [
          {
            title: "售前省心",
            content:
              "1. 合同生效前，我们将根据客户要求派专业技术人员现场考察，为客户提供最佳配套方案。<br />2. 我们将向用户提供必要的考察便利和相关技术咨询服务。"
          },
          {
            title: "售中安心",
            content: `
              1. 免费送货，根据客户要求送到指定地点(国内)。<br />
              2. 交货期间，免费派技术工程师到现场指导设备操作。<br />
              3. 免费为客户使用人员提供技术培训。<br />
              4. 产品在运输过程中出现的任何破损，均由本公司负责修理、情况严重时可负责退换。
            `
          },
          {
            title: "售后放心",
            content: `
              1. 产品保修一年，保修期内提供软件免费升级。<br />
              2. 所售产品公司负责终身维护，只收取工本费。<br />
              3. 因操作或使用不当造成设备损坏，我们将积极配合对产品进行修复、更换，并以最优惠的价格提供所需换零部件。<br />
              4. 公司及时为用户解决问题，提供快速响应，并根据实际情况尽快解决问题。<br />
              5. 全面的技术支持系统和售后服务体系为客户提供尽善尽美售后技术服务。

            `
          }
        ]
      },
      qualityBook: {
        title: "质量承诺书",
        arr: [
          {
            title: "我公司为保证设备质量，特向客户作出如下承诺",
            content: `
              1、严格按照合同要求，提供符合设计标准，质量合格的产品。<br />
              2、严格检查和控制原材料、元器件、配套件的进厂质量。<br />
              3、保证所供设备加工工艺完善、检测手段完备；产品绝不带缺陷出厂。<br />
              4、对涉及分包商的供货、质量、设备性能、技术接口、服务等方面问题负全部责任；按合同规定的关键部件的分包须符合有关资质的要求，并经需方确认。<br />
              5、按合同规定向监造单位提供有部门标准和图纸，并为监造提供方便。<br />
              6、对设备制造过程中出现的质量缺陷超过合同规定的标准，供方无条件更换；在安装和试运行过程中，设备出现质量问题，先处理问题，再分清责任，一切以满足工程进度需要为准则。<br />
              7、为所供的设备在制造、运输、装卸过程中担保，一旦发生意外，我方将按需方要求对所供设备尽快进行免费更换修理，直到需方满意为止。<br />
              8、开箱工作由需方代表和制造厂代表共同进行，开箱过程中如发现缺件及零部件丢失损坏，我方负责补齐所缺零部件；在设备的安装、调试过程中以及今后在设备运行中发现的质量问题，如属我方原因，我方将承担责任，赔偿需方所受到的直接经济损失。
            `
          }
        ]
      },
      serverBook: {
        title: "服务承诺书",
        arr: [
          {
            title: "我公司对合同设备的服务郑重承诺如下",
            content: `
              1、及时向需方提供按合同规定的全部技术资料和图纸，有义务在必要时邀请需方参与供方的技术设备审查。<br />
              2、按需方要求的时间到现场进行技术服务，指导需方按供方的技术资料和图纸进行安装、调试。<br />
              3、对于需方选购的合同设备有关的配套设备，供方应主动提供满足设备接口要求的技术条件和资料。<br />
              4、严格执行供需双方就有关问题召开会议的纪要或签订的协议。<br />
              5、按合同规定为需方举办有关设备安装、调试、使用、维护技术的业务学习。<br />
              6、加强售后服务，把“24小时服务”、“超前服务”、“全过程服务”、“终身服务”贯彻在产品制造、安装、调试的全过程。<br />
              7、接到需方反映的质量问题信息后，在24小时之内作出答复或派出服务人员，尽快到达现场，做到用户对质量不满意，服务不停止；随时满足需方对备品备件的要求。
            `
          }
        ]
      }
    };
  }
};
</script>
